import { Reducer } from 'redux';
import { AppState } from '../types/store';
import { reducers as sharedReducers } from '@wix/da-shared-react/pkg/redux/shared';
import deviationSubmitPopupReducers from '@wix/da-submit-shared/pkg/redux/reducers';
import studioReducer from './studio';
import stashReducer from './stash';
import { default as headReducers } from '@wix/da-react-app/pkg/client/Head/redux/reducers';

const buildFakeReducer =
  defaultValue =>
  (state = defaultValue, action) =>
    state;

// This type makes sure we do not forget to add a reducer for any slice
// of the store nor can we add extras for non-existing slices.
// Needed because monday (thursday) mornings exist.

type AppStateKeys = keyof AppState;
type AppStateReducersMapObject = { [k in AppStateKeys]: Reducer<any> };

const reducers: AppStateReducersMapObject = {
  ...headReducers,
  editor: buildFakeReducer({}),
  studio: studioReducer,
  stash: stashReducer,
  submit: buildFakeReducer({}),
  ...deviationSubmitPopupReducers,
  ...sharedReducers,
};

export default reducers;
